// useage: showToast('Hello World');
// useage: showToast({ message: 'Hello World', type: 'success', time: 3000 });

function showToast(options) {
  // 参数处理
  const isString = typeof options === 'string';
  const config = isString ? {
    message: options
  } : options;

  // 配置解析
  const {
    type = 'default',
    message = isString ? options : config.message,
    time = 2000
  } = config;

  // 创建 Toast 元素
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  toast.textContent = message;

  // 获取或创建容器
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  // 添加 Toast 到容器
  container.appendChild(toast);

  // 触发入场动画
  setTimeout(() => toast.classList.add('active'));

  // 自动关闭
  setTimeout(() => {
    toast.classList.remove('active');
    toast.addEventListener('transitionend', () => {
      toast.remove();
      // 清理空容器
      if (container && container.children.length === 0) {
        container.remove();
      }
    });
  }, time);
}
